export default __webpack_public_path__ + "static/media/0xGuard_logo.69fd194c.png";